import React from 'react';
import { SectionHeading } from './SectionHeading';
import { processSteps } from '../data/process';
export function Process() {
  return <section aria-labelledby="proceso-titulo" className="py-20 lg:py-28" data-id="element-208" data-mp="1uc23xoif24rg">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-209" data-mp="1yg9ulr8fpusb">
        <div id="proceso-titulo" data-id="element-210" data-mp="23ebcw9y1dq2q">
          <SectionHeading title="Cómo trabajamos tu proyecto" data-id="element-211" data-mp="23ejs48hmt7h3" />
        </div>

        <ol className="relative mt-12 grid gap-8 lg:grid-cols-4 lg:gap-6" data-id="element-212" data-mp="16oasso8m3xrr">
          <span aria-hidden="true" className="absolute left-[15px] top-2 hidden h-px w-full bg-white/10 lg:block" data-id="element-213" data-mp="16m7qp5u6qe6o" />
          {processSteps.map(step => <li key={step.id} className="relative flex flex-col lg:pr-6" data-id="element-214" data-mp="1fmmfwga9sdfg">
              <span className="relative z-10 grid h-8 w-8 place-items-center rounded-full border border-neon/60 bg-ink-950 text-xs font-semibold text-neon" data-id="element-215" data-mp="1kh0fkuvyt6px">
                {step.step}
              </span>
              <h3 className="mt-5 text-base font-semibold text-white" data-id="element-216" data-mp="rxjwp3zzmciu">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-mist-muted" data-id="element-217" data-mp="19jxwrndtpsfp">{step.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}